import React from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import KpiNumberTile from "./KpiNumberTile";
import { nv, periodDelta } from "./utils";
import { useTrendsData } from "./hooks/useTrendsData";

const pick = (s) => (s.crawlScopeStats?.internal ?? 0) + (s.crawlScopeStats?.external ?? 0);

export default function KpiPageCrawledTile({ startDate, endDate, lastN, onFilter, onInvestigate }) {
    const { workspaceNumber } = useParams();
    const live = useSelector((s) => s.stats?.workspaceStats);
    const { series, days } = useTrendsData({ workspaceNumber, startDate, endDate, lastN });

    const value = pick(live || {});
    const internal = Number(live?.crawlScopeStats?.internal ?? 0);
    const external = Number(live?.crawlScopeStats?.external ?? 0);

    return (
        <KpiNumberTile
            title="Pages"
            info="Total URLs discovered in the workspace right now. Change is measured across the selected period — up = good."
            sparkColor="#2563eb"
            value={live?.fetched ? value : "—"}
            valueTooltip={live?.fetched ? `Internal: ${nv(internal)} • External: ${nv(external)}` : undefined}
            delta={periodDelta(value, days, pick)}
            invertDelta
            sparkSeries={series(pick)}
            onFilter={onFilter}
            onInvestigate={onInvestigate}
        />
    );
}
